<template>
	<article class="itv-social-button" v-click-outside="() => clickOutside()">
		<button
			class="itv-social-button__trigger"
			@click.prevent="showList = !showList"
		>
			<svg
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M11.4849 1.33333C10.6481 1.33333 9.96973 2.01169 9.96973 2.84849C9.96973 3.13737 10.0506 3.40737 10.1909 3.6371C10.1976 3.64651 10.2042 3.65614 10.2105 3.66599C10.2169 3.67585 10.2229 3.68582 10.2287 3.69588C10.501 4.09877 10.962 4.36364 11.4849 4.36364C12.3217 4.36364 13 3.68528 13 2.84849C13 2.01169 12.3217 1.33333 11.4849 1.33333ZM9.51477 4.9058C10.0264 5.39587 10.7205 5.69697 11.4849 5.69697C13.0581 5.69697 14.3334 4.42166 14.3334 2.84849C14.3334 1.27531 13.0581 0 11.4849 0C9.91171 0 8.6364 1.27531 8.6364 2.84849C8.6364 3.1763 8.69177 3.49118 8.79368 3.78429L5.81623 5.69836C5.30483 5.20963 4.61171 4.90946 3.84849 4.90946C2.27531 4.90946 1 6.18477 1 7.75795C1 9.33113 2.27531 10.6064 3.84849 10.6064C4.61243 10.6064 5.30613 10.3057 5.81766 9.81617L8.79394 11.7295C8.69187 12.0228 8.6364 12.3379 8.6364 12.666C8.6364 14.2392 9.91171 15.5145 11.4849 15.5145C13.0581 15.5145 14.3334 14.2392 14.3334 12.666C14.3334 11.0929 13.0581 9.81755 11.4849 9.81755C10.7208 9.81755 10.0269 10.1184 9.51534 10.6082L6.53926 8.69497C6.64144 8.40152 6.69697 8.08622 6.69697 7.75795C6.69697 7.42898 6.64121 7.11303 6.53861 6.81905L9.51477 4.9058ZM5.13731 8.55498C5.2808 8.32345 5.36364 8.05037 5.36364 7.75795C5.36364 6.92115 4.68528 6.2428 3.84849 6.2428C3.01169 6.2428 2.33333 6.92115 2.33333 7.75795C2.33333 8.59475 3.01169 9.2731 3.84849 9.2731C4.37429 9.2731 4.83754 9.00527 5.10924 8.59858C5.11356 8.59128 5.11803 8.58403 5.12265 8.57684C5.12742 8.56943 5.1323 8.56214 5.13731 8.55498ZM10.196 11.869C10.201 11.862 10.2058 11.8548 10.2104 11.8476C10.215 11.8404 10.2195 11.8332 10.2238 11.8259C10.4954 11.419 10.9588 11.1509 11.4849 11.1509C12.3217 11.1509 13 11.8292 13 12.666C13 13.5028 12.3217 14.1812 11.4849 14.1812C10.6481 14.1812 9.96973 13.5028 9.96973 12.666C9.96973 12.3736 10.0526 12.1006 10.196 11.869Z"
					fill="#252628"
				/>
			</svg>
		</button>
		<Transition name="slide-fade">
			<ul v-show="showList" class="itv-social-button__list">
				<li
					v-for="(item, i) in content"
					:key="i"
					class="itv-social-button__item"
				>
					<a class="itv-social-button__link" :href="item.href">
						<span class="itv-social-button__icon" v-html="item.icon"></span>
						<span class="itv-social-button__text" v-html="item.text"></span>
					</a>
				</li>
			</ul>
		</Transition>
	</article>
</template>

<script>
import vClickOutside from 'click-outside-vue3'

export default {
	name: 'SocialButton',
	directives: {
		clickOutside: vClickOutside.directive,
	},
	props: {
		content: {
			type: Array,
			default: () => {},
		},
	},
	data() {
		return {
			showList: false,
		}
	},
	methods: {
		clickOutside() {
			this.showList = false
		},
	},
}
</script>
